export const getGaClientId = () =>
  window.ga && window.ga.getAll && window.ga.getAll()[0] && window.ga.getAll()[0].get('clientId');



// WEBPACK FOOTER //
// ./src/utils/gaClientId.js